// Brand action icons for contact records and My Card. Inline SVGs (official
// glyph paths) — no external assets, works offline, one tap = open the page.

const PATHS = {
  facebook:
    "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
  linkedin:
    "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
  twitter:
    "M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z",
  instagram:
    "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z",
  phone:
    "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z",
  email:
    "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z",
  website:
    "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z",
  address:
    "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
};

const COLORS = {
  facebook: "#1877F2",
  linkedin: "#0A66C2",
  twitter: "#000000",
  instagram: "#E4405F",
  phone: "#16a34a",
  email: "#1e3a8a",
  website: "#475569",
  address: "#DC2626",
};

function Icon({ kind }) {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="white" aria-hidden="true">
      <path d={PATHS[kind]} />
    </svg>
  );
}

// Small inline brand badge for the Social composer/calendar — the same
// official glyphs as the contact buttons, sized to sit next to text. Social
// uses "x" as the platform key; the glyph lives under "twitter".
export function PlatformBadge({ platform, className = "h-5 w-5" }) {
  const kind = platform === "x" ? "twitter" : platform;
  if (!PATHS[kind]) return null;
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full ${className}`}
      style={{ backgroundColor: COLORS[kind] }}
      aria-label={platform}
    >
      <svg viewBox="0 0 24 24" className="h-[62%] w-[62%]" fill="white" aria-hidden="true">
        <path d={PATHS[kind]} />
      </svg>
    </span>
  );
}

function ActionIcon({ kind, href, label, external }) {
  return (
    <a
      href={href}
      aria-label={label}
      {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
      className="flex h-11 w-11 items-center justify-center rounded-full shadow-sm active:opacity-70"
      style={{ backgroundColor: COLORS[kind] }}
    >
      <Icon kind={kind} />
    </a>
  );
}

// Renders only the actions that exist on the record. `person` can be a contact
// row (facebook_url, …) or a my-card object (facebook, …) — both key styles work.
export default function ContactActions({ person }) {
  const get = (k) => person[`${k}_url`] || person[k];
  const actions = [
    person.phone && { kind: "phone", href: `tel:${person.phone}`, label: "Call" },
    person.email && { kind: "email", href: `mailto:${person.email}`, label: "Email" },
    person.website && { kind: "website", href: person.website, label: "Website", external: true },
    person.address && {
      kind: "address",
      // Apple Maps directions — opens the native Maps app on iPhone.
      href: `https://maps.apple.com/?daddr=${encodeURIComponent(person.address)}`,
      label: "Directions",
      external: true,
    },
    get("facebook") && { kind: "facebook", href: get("facebook"), label: "Facebook", external: true },
    get("linkedin") && { kind: "linkedin", href: get("linkedin"), label: "LinkedIn", external: true },
    get("twitter") && { kind: "twitter", href: get("twitter"), label: "X (Twitter)", external: true },
    get("instagram") && { kind: "instagram", href: get("instagram"), label: "Instagram", external: true },
  ].filter(Boolean);
  if (!actions.length) return null;
  return (
    <div className="flex flex-wrap gap-3">
      {actions.map((a) => (
        <ActionIcon key={a.kind} {...a} />
      ))}
    </div>
  );
}
